const defaultState = { search: { items: [] }, list: { items: {} } };

export default defaultState;
